import { useProductSummary } from '../hooks/useProductSummary';

type ContainerProps = { children: React.ReactNode };

const Container = ({ children }: ContainerProps) => {
	const { blockClass, componentId } = useProductSummary();
	return (
		<section
			data-selection={componentId}
			className={`container containerNormal container--${blockClass} containerNormal--${blockClass} vtex-product-summary-2-x-container vtex-product-summary-2-x-container--${blockClass} vtex-product-summary-2-x-containerNormal vtex-product-summary-2-x-containerNormal--${blockClass} overflow-hidden br3 h-100 w-100 flex flex-column justify-between center tc`}
			style={{ maxWidth: '300px' }}
		>
			{children}
		</section>
	);
};

export default Container;
